import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import { useAuth } from '@/context/AuthContext';

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading, requestLogin } = useAuth();
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    if (!loading) {
      setSlow(false);
      return;
    }
    const t = window.setTimeout(() => setSlow(true), 5000);
    return () => window.clearTimeout(t);
  }, [loading]);

  useEffect(() => {
    if (!loading && !user) {
      requestLogin();
    }
  }, [loading, user, requestLogin]);

  if (loading) {
    return (
      <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center gap-4 px-6 text-center">
        <div className="w-10 h-10 rounded-full border-2 border-background-200 border-t-primary-500 animate-spin"></div>
        <p className="text-sm text-foreground-500">正在加载…</p>
        {slow ? (
          <p className="text-xs text-foreground-400 max-w-sm leading-relaxed">
            后端响应较慢（常见于深度挖掘进行中或热重载等待长请求结束）。可稍候刷新；深挖联调建议去掉
            uvicorn --reload。
          </p>
        ) : null}
      </div>
    );
  }

  if (!user) {
    return (
      <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center gap-4 px-6 text-center">
        <div className="w-14 h-14 rounded-2xl bg-primary-500/10 flex items-center justify-center">
          <i className="ri-lock-line text-2xl text-primary-500" aria-hidden />
        </div>
        <p className="text-base font-medium text-foreground-900">登录后继续</p>
        <p className="text-sm text-foreground-500 max-w-sm">该页面需要登录。关闭登录弹窗后可再次点击下方按钮。</p>
        <button
          type="button"
          onClick={() => requestLogin()}
          className="h-10 px-5 rounded-lg bg-primary-500 text-sm font-semibold text-background-50 hover:bg-primary-600 cursor-pointer"
        >
          登录
        </button>
      </div>
    );
  }

  return <>{children}</>;
}
